import { FieldValues, useController, UseControllerProps } from "react-hook-form";
import { Select, SelectProps } from "@airhelp/react";
import { useTranslation } from "react-i18next";
import { handleFieldChange } from "./handleFieldChange";

type ControlledTotalDelaySelectProps<
  Option,
  TFieldValues extends FieldValues,
> = UseControllerProps<TFieldValues> &
  Partial<SelectProps<SelectOption<Option>>> & {
    handleChange?: () => void;
  };

export function ControlledSelect<Option, T extends FieldValues>({
  name,
  rules,
  shouldUnregister,
  control,
  options,
  handleChange,
  ...props
}: ControlledTotalDelaySelectProps<Option, T>) {
  const { t } = useTranslation();
  const { field } = useController({
    name,
    rules,
    shouldUnregister,
    control,
  });

  return (
    <Select<SelectOption<Option>>
      {...props}
      formControlStyles={{
        w: {
          base: "100%",
          md: "75%",
        },
      }}
      name={field.name}
      placeholder={t("steps.total_delay.saudi_arabia.select_placeholder")}
      options={options}
      // @ts-ignore
      value={field.value ? options?.find((option: any) => option.value === field.value) : ""}
      handleChange={(option) => {
        handleChange && handleChange();
        handleFieldChange(field, option?.value || "");
      }}
    />
  );
}

interface SelectOption<T> {
  label: string;
  value: T;
}
